import { useTranslation } from "react-i18next";
import { z } from "zod";

export const useAddBillPdfMethodAutomaticParsingModalSchema = (
  isIbanRequired: boolean,
) => {
  const { t } = useTranslation();

  const schema = z.object({
    house: z.number({
      required_error: t("common.form.field.errors.required"),
    }),
    customerCode: z
      .string({
        required_error: t("common.form.field.errors.required"),
      })
      .optional(),
    iban: z.string({
      required_error: t("common.form.field.errors.required"),
    }),
    total: z
      .number({ required_error: t("common.form.field.errors.required") })
      .or(z.string({ required_error: t("common.form.field.errors.required") })),
  });

  return schema.pick({
    house: true,
    customerCode: true,
    iban: isIbanRequired ? true : undefined,
    total: true,
  });
};

export type TAddBillPdfMethodAutomaticParsingModalSchema = z.infer<
  ReturnType<typeof useAddBillPdfMethodAutomaticParsingModalSchema>
>;
